(ns net.kestec.mhda-pilgrimage.public.application.application-form
  (:require
    ["@mui/material/Typography" :default Typography]
    ["@mui/material/MobileStepper" :default MobileStepper]
    ["@mui/material/Button" :default Button]
    ["@mui/material/Stepper" :default Stepper]
    ["@mui/material/Step" :default Step]
    ["@mui/material/StepLabel" :default StepLabel]
    ["@mui/material/Paper" :default Paper]
    ["@mui/material/Chip" :default Chip]

    ["@mui/icons-material/KeyboardArrowLeft" :default KeyboardArrowLeft]
    ["@mui/icons-material/KeyboardArrowRight" :default KeyboardArrowRight]
    ["@mui/icons-material/CheckCircle" :default CheckCircle]

    [net.kestec.mhda-pilgrimage.public.application.form.application-form-step1 :as application-form-step1]
    [net.kestec.mhda-pilgrimage.public.application.form.application-form-step2 :as application-form-step2]
    [net.kestec.mhda-pilgrimage.public.application.form.application-form-step3 :as application-form-step3]
    [net.kestec.mhda-pilgrimage.public.application.form.application-form-step4 :as application-form-step4]
    [net.kestec.mhda-pilgrimage.public.application.form.application-form-step5 :as application-form-step5]
    [net.kestec.mhda-pilgrimage.public.application.form.application-form-step6 :as application-form-step6]
    [net.kestec.mhda-pilgrimage.public.application.application-events :as-alias application-events]
    [net.kestec.mhda-pilgrimage.lib-ui.form-validator :refer [form-data-validator form-validator]]
    [net.kestec.mhda-pilgrimage.public.page-structure :refer [base-page]]
    [net.kestec.mhda-pilgrimage.db :as db]
    [net.kestec.mhda-pilgrimage.route :as route]
    [day8.re-frame.http-fx]
    [reagent.core :as r]
    [re-frame.core :as rf]

    ))

(def !stepper-el (r/atom nil))

(defn steps-done? [application]
  (and
    (:valid (form-data-validator application-form-step1/VALIDATOR application))
    (:valid (form-data-validator application-form-step2/VALIDATOR application))
    (:valid (form-data-validator application-form-step3/VALIDATOR application))
    (:valid (form-data-validator application-form-step4/VALIDATOR application))
    (:valid (form-data-validator application-form-step5/VALIDATOR application))
    (:valid (form-data-validator application-form-step6/VALIDATOR application))
    ))

(defn steps-missing-chips [application]
  (when-not (steps-done? application)
    (into
      [:<> "Es fehlen noch folgende Eingaben: " [:br]
       (when-not (:valid (form-data-validator application-form-step1/VALIDATOR application))
         [:> Chip {:label   (str "Informationen nicht bestätigt")
                   :onClick #(rf/dispatch [::application-events/jump-to-step (:pilgrimage application) (:id application) 0])
                   :sx      {:backgroundColor "var(--color-mhda-red)" :color "var(--color-mhda-red-text)"}}])
       (when-not (:valid (form-data-validator application-form-step2/VALIDATOR application))
         [:> Chip {:label   (str "Persönliche Daten")
                   :onClick #(rf/dispatch [::application-events/jump-to-step (:pilgrimage application) (:id application) 1])
                   :sx      {:backgroundColor "var(--color-mhda-red)" :color "var(--color-mhda-red-text)"}}])
       (when-not (:valid (form-data-validator application-form-step3/VALIDATOR application))
         [:> Chip {:label   (str "Kurzfragebogen")
                   :onClick #(rf/dispatch [::application-events/jump-to-step (:pilgrimage application) (:id application) 2])
                   :sx      {:backgroundColor "var(--color-mhda-red)" :color "var(--color-mhda-red-text)"}}])
       (when-not (:valid (form-data-validator application-form-step4/VALIDATOR application))
         [:> Chip {:label   (str "Reisedetails / Notfallkontakt")
                   :onClick #(rf/dispatch [::application-events/jump-to-step (:pilgrimage application) (:id application) 3])
                   :sx      {:backgroundColor "var(--color-mhda-red)" :color "var(--color-mhda-red-text)"}}])
       (when-not (:valid (form-data-validator application-form-step5/VALIDATOR application))
         [:> Chip {:label   (str "Bildrechte")
                   :onClick #(rf/dispatch [::application-events/jump-to-step (:pilgrimage application) (:id application) 4])
                   :sx      {:backgroundColor "var(--color-mhda-red)" :color "var(--color-mhda-red-text)"}}])
       (when-not (:valid (form-data-validator application-form-step6/VALIDATOR application))
         [:> Chip {:label   (str "Unterschrift")
                   :onClick #(rf/dispatch [::application-events/jump-to-step (:pilgrimage application) (:id application) 5])
                   :sx      {:backgroundColor "var(--color-mhda-red)" :color "var(--color-mhda-red-text)"}}])
       ]
      ))
  )



(defn custom-step-icon [js-props form-valid]
  (let [props (js->clj js-props :keywordize-keys true)
        active (:active props)
        ;completed (:completed props)
        ;icon-num (:icon props)
        sx_ {:color     (if (:valid form-valid) "green" "darkred")
             :font-size "30px" :borderRadius "20px"
             :border    (if active "2px solid black" "2px solid transparent")}]
    (r/as-element
      [:> CheckCircle {:sx sx_}]
      )))

(defn main []
  (if-not (db/has-session?)
    (rf/dispatch [::route/push ::route/public.landing])
    (let [actual-step (int @(rf/subscribe [::application-events/get-step]))
          !application (rf/subscribe [::db/get ::db/selected-application])]
      [base-page
       [:> Paper {:sx {:padding "7px"}}
        [:br]
        [:> Typography {:variant "h2"} "ANMELDUNG    - " [:span {:style {:color "darkblue"}} (:shown_first_name @!application) " " (:shown_last_name @!application)] " - "]
        [:br]
        [:> Typography {:variant "h3"} "für die MALTESER Rom-Wallfahrt 2026"]


        [:br]
        [:> Stepper {:activeStep       actual-step
                     :alternativeLabel true
                     :ref              #(reset! !stepper-el %)
                     }
         [:> Step {:key 0 :onClick #(rf/dispatch [::application-events/set-step 0])}
          [:> StepLabel {:StepIconComponent #(custom-step-icon % (form-validator application-form-step1/VALIDATOR !application))}
           [:> Typography {:variant "span" :sx {:display {:xs "none" :md "block"}}} "Informationen"]]]

         [:> Step {:key 1 :onClick #(rf/dispatch [::application-events/set-step 1])}
          [:> StepLabel {:StepIconComponent #(custom-step-icon % (form-validator application-form-step2/VALIDATOR !application))}
           [:> Typography {:variant "span" :sx {:display {:xs "none" :md "block"}}} "Persönliche Daten"]]]

         [:> Step {:key 2 :onClick #(rf/dispatch [::application-events/set-step 2])}
          [:> StepLabel {:StepIconComponent #(custom-step-icon % (form-validator application-form-step3/VALIDATOR !application))}
           [:> Typography {:variant "span" :sx {:display {:xs "none" :md "block"}}} "Kurzfragebogen"]]]

         [:> Step {:key 3 :onClick #(rf/dispatch [::application-events/set-step 3])}
          [:> StepLabel {:StepIconComponent #(custom-step-icon % (form-validator application-form-step4/VALIDATOR !application))}
           [:> Typography {:variant "span" :sx {:display {:xs "none" :md "block"}}} "Reisedetails / Notfallkontakt"]]]

         [:> Step {:key 4 :onClick #(rf/dispatch [::application-events/set-step 4])}
          [:> StepLabel {:StepIconComponent #(custom-step-icon % (form-validator application-form-step5/VALIDATOR !application))}
           [:> Typography {:variant "span" :sx {:display {:xs "none" :md "block"}}} "Bildrechte"]]]

         [:> Step {:key 5 :onClick #(rf/dispatch [::application-events/set-step 5])}
          [:> StepLabel {:StepIconComponent #(custom-step-icon % (form-validator application-form-step6/VALIDATOR !application))}
           [:> Typography {:variant "span" :sx {:display {:xs "none" :md "block"}}} "Finanzieller Beitrag / Abschluss"]]]
         ]
        [:br]
        [:> Typography {:variant "p" :sx {:color "darkred"}}
         ;"Bitte unbedingt alle Blätter dieses Formulars vollständig und leserlich ausfüllen und Ihre Adresse und Telefonnummer für allfällige Rückfragen angeben! "
         "Füllen Sie dieses Formular ehrlich vollständig aus. Geben Sie außerdem unbedingt Ihre aktuelle Adresse sowie Telefonnummer für eventuelle Rückfragen an."
         ]



        [:br]
        [:br]
        (case actual-step
          1 [application-form-step2/main]
          2 [application-form-step3/main]
          3 [application-form-step4/main]
          4 [application-form-step5/main]
          5 [application-form-step6/main]
          [application-form-step1/main]
          )


        [:br]


        ;[:pre (pr-str @!stepper-el)]



        [:> MobileStepper {:variant    "dots"
                           :steps      6
                           :position   "static"             ; without its always on top
                           :sx         {:width "calc(100%-10px)" :maxWidth "1680px" :flexGrow 1 :margin "0 auto 0 auto"}
                           :activeStep actual-step
                           :nextButton (r/as-element (if (= actual-step 5)
                                                       [:> Button
                                                        {:component "a" :href "/dashboard"
                                                         :variant   "outlined"}
                                                        [:> KeyboardArrowRight] "Übersicht"]
                                                       [:> Button
                                                        {:variant "outlined"
                                                         :onClick (fn [_]
                                                                    (rf/dispatch [::application-events/set-step (inc actual-step)])
                                                                    (.scrollIntoView @!stepper-el #js {:behavior "smooth"}))
                                                         :color   "secondary"}
                                                        "Weiter" [:> KeyboardArrowRight]]))
                           :backButton (r/as-element (if (= actual-step 0)
                                                       [:> Button
                                                        {:component "a" :href "/dashboard"
                                                         :variant   "outlined"}
                                                        [:> KeyboardArrowLeft] "Übersicht"]
                                                       [:> Button
                                                        {:onClick (fn [_]
                                                                    (rf/dispatch [::application-events/set-step (dec actual-step)])
                                                                    (.scrollIntoView @!stepper-el #js {:behavior "smooth"}))
                                                         :variant "outlined"}
                                                        [:> KeyboardArrowLeft] "Zurück"]))

                           }
         ]

        ]])))